import React, { useEffect, useState, useRef } from "react"
import PropTypes from 'prop-types'
import {
	Button,
	Card,
	CardBody,
	Col,
	Container,
	Row,
} from "reactstrap"
import moment from "moment"
import { useRouteMatch, useHistory,Link } from "react-router-dom"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { CheckPicker } from 'rsuite'
import Loader from "../../../components/Loader/Loader"
import { Dropdown } from "react-bootstrap"
import { GoKebabVertical } from 'react-icons/go'
//Helpers
import isValidUrl from "../../../helpers/url_checker"
//GraphQL
import { MerchantProductList } from "gql/query"
import { useQuery } from "@apollo/client"

const SubServices = (props) => {

 	
	const history = useHistory()
	const [products, setProducts] = useState([])
	const FormatData = (data) => {
 		const ServiceDetails = data.map(elem => {
			return {
				 ...elem,
				 "sub_service_name":elem?.sub_service?.name,
				 "category":elem?.sub_service?.service_category?.category,				  
				 "service_type":elem?.sub_service?.service_category?.service_type,				  
			}
		})
		return ServiceDetails
	}
	const columns = [
		{
			text: "id",
			dataField: "id",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "SubService",
			dataField: "sub_service_name",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Category",
			dataField: "category",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Service Type",
			dataField: "service_type",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
 
		{
			text: "Center Price",
			dataField: "centre_price",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},

		{
			text: "HomePrice",
			dataField: "home_price",
			sort: true,
			// hidden: true,
			// eslint-disable-next-line react/display-name
		},
		{
			text: "Deleted",
			dataField: "is_deleted",
			sort: true,
			formatter: (cellContent, row) => row?.delete ? "True":"False" 
			 
		},
		{
			text: "Active",
			dataField: "active",
			sort: true,
			formatter: (cellContent, row) => row?.delete ? "True":"False" 
			 
		},

    
		// {
		// 	dataField: "view",
		// 	isDummyField: true,
		// 	text: "Action",
		// 	sort: false,
		// 	// eslint-disable-next-line react/display-name
		// 	formatter: (cellContent, row) => (
		// 	  <Dropdown>
		// 		<Dropdown.Toggle variant="transparent" id="dropdown-basic">
		// 		  <GoKebabVertical />
		// 		</Dropdown.Toggle>
		// 		<Dropdown.Menu>
		// 		  <Dropdown.Item onClick={() => history.push(`/ecommerce-products/detail/${row.product_id}`)}>View Details</Dropdown.Item>
		// 		</Dropdown.Menu>
		// 	  </Dropdown>
		// 	),
		//   },
	]
	const defaultSorted = []
	useEffect(() => {
		if (props.data) {
			setProducts(FormatData(props.data))
		}
	}, [props.data])
	
	return (
		<div className="p-3">
			<Row className="mb-5">
				<Row className="mb-2">
					<Col sm="8">
						{props.showLabel && (
							<h4>{props.label}</h4>
						)}
					</Col>
					<Col sm="4">
						<div className="text-sm-end d-flex justify-content-end">
							
						</div>
					</Col>
				</Row>
				<hr />
				<ToolkitProvider
					keyField="id"
					data={products || []}
					columns={columns}
					bootstrap4
				// search
				>
					{toolkitProps => (
						<>
							<Row>
								<Col xl="12">
									<div className="table-responsive">
										{false ? <Loader /> :
											<BootstrapTable
												responsive
												bordered={false}
												striped={false}
												defaultSorted={defaultSorted}
												classes={"table align-middle table-nowrap"}
												keyField="id"
												{...toolkitProps.baseProps}
												onTableChange={() => { }}
												noDataIndication={() => "No Products Found!"}
											// {...paginationTableProps}
											/>
										}
									</div>
								</Col>
							</Row>
						</>
					)}
				</ToolkitProvider>
			</Row>
		</div>
	)
}
SubServices.propTypes = {
	order: PropTypes.any,
	showLabel: PropTypes.bool,
	label: PropTypes.string,
	data: PropTypes.any,
}
SubServices.displayName = 'SubServices'
export default SubServices